import { COST_SIMULATION_YEARS } from "@repo/shared";

// Local translations
export const T = {
  en_GB: {
    costChartDisplayMode: "Display Mode",
    rolling12Months: "Rolling 12 Months",
    calendarYear: "Calendar Year",
    costChartHelp: "Choose how to display the cost projection timeline",
    costChartModeInfo: "ℹ️ Display Mode",
    costChartRollingDesc:
      "Shows cost projections in rolling 12-month periods starting from the current date.",
    costChartCalendarDesc: "Shows cost projections aligned to calendar years (Jan-Dec).",
    chartType: "Chart Type",
    lineChart: "Line chart",
    barChart: "Bar chart",
    projectionYears: "Projection length (years)",
    projectionYearsDesc: `How many years of the cost projection to display (2-${COST_SIMULATION_YEARS}).`,
    required: "*",
  },
  nb_NO: {
    costChartDisplayMode: "Visningsmodus",
    rolling12Months: "Rullerende 12 måneder",
    calendarYear: "Kalenderår",
    costChartHelp: "Velg hvordan kostnadsframskrivningen skal vises",
    costChartModeInfo: "ℹ️ Visningsmodus",
    costChartRollingDesc:
      "Viser kostnadsframskrivninger i rullerende 12-månedersperioder fra dagens dato.",
    costChartCalendarDesc: "Viser kostnadsframskrivninger justert til kalenderår (jan-des).",
    chartType: "Diagramtype",
    lineChart: "Linjediagram",
    barChart: "Stolpediagram",
    projectionYears: "Framskrivningslengde (år)",
    projectionYearsDesc: `Hvor mange år av kostnadsframskrivningen som vises (2-${COST_SIMULATION_YEARS}).`,
    required: "*",
  },
} as const;
